// Pure drop-permission rules for the Kanban board. DOM-free (no React, dnd-kit,
// or browser globals), so every accept/reject combination can be enumerated
// directly instead of being driven through a drag gesture.

/**
 * Whether releasing a dragged card should commit a move. Rejected board-wide
 * when `isDropDisabled` (grouped views where a cross-column move is meaningless)
 * — the card snaps back. Otherwise needs a valid over-target, active item, and
 * source column.
 */
export function shouldCommitDrop(args: {
  isDropDisabled: boolean;
  hasOver: boolean;
  hasItem: boolean;
  hasFromColumn: boolean;
}): boolean {
  if (args.isDropDisabled) return false;
  return args.hasOver && args.hasItem && args.hasFromColumn;
}

/**
 * Whether a column should veil its body with the drop-disabled overlay. Only
 * while a card is actually in flight (`hasActiveItem`) and drops are disabled —
 * a static board shows nothing. Every column veils; only the hovered column
 * additionally shows the explanatory content (gated separately in the column).
 */
export function shouldShowDropDisabledVeil(args: {
  isDropDisabled: boolean;
  hasActiveItem: boolean;
}): boolean {
  return args.isDropDisabled && args.hasActiveItem;
}
